import { render, staticRenderFns } from "./AddToCatalog.vue?vue&type=template&id=2e55dd29&"
import script from "./AddToCatalog.vue?vue&type=script&lang=js&"
export * from "./AddToCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports